module.exports = __webpack_public_path__ + "img/entrepreneurs.e1e40cb0.svg";